var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"more-images",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.showLightbox()}}},[_vm._t("default",function(){return [_c('img',{staticClass:"enlarge-icon",attrs:{"src":require("img/enlarge-01.svg")}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }